import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@promo-platform/error-message';
import { FieldHead } from '@promo-platform/field-head';
import { useConditionsWatch } from '@promo-platform/utils';
import classNames from 'classnames';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
var IntegerField = function IntegerField(_ref) {
  var defaultValue = _ref.defaultValue,
    mandatoryValidation = _ref.mandatoryValidation,
    minValueValidation = _ref.minValueValidation,
    maxValueValidation = _ref.maxValueValidation,
    id = _ref.id,
    label = _ref.label,
    tooltip = _ref.tooltip,
    tooltipLabel = _ref.tooltipLabel,
    description = _ref.description,
    alias = _ref.alias,
    isHidden = _ref.isHidden,
    conditions = _ref.conditions;
  var _a;
  var _useFormContext = useFormContext(),
    register = _useFormContext.register,
    unregister = _useFormContext.unregister,
    setValue = _useFormContext.setValue,
    getValues = _useFormContext.getValues,
    errors = _useFormContext.formState.errors,
    watch = _useFormContext.watch;
  var shouldRender = useConditionsWatch(watch, conditions);
  useEffect(function () {
    if (!shouldRender) {
      unregister(alias);
    }
  }, [shouldRender, unregister, alias]);
  return shouldRender ? jsxs("div", Object.assign({
    className: classNames('pp-integer-field', {
      'pp-integer-field--hidden': isHidden
    })
  }, {
    children: [jsx(FieldHead, {
      id: id,
      label: label,
      description: description,
      tooltipText: tooltip,
      tooltipLabel: tooltipLabel
    }), jsxs("div", Object.assign({
      className: "pp-integer-field__field-wrapper"
    }, {
      children: [jsx("button", {
        className: "pp-integer-field__button pp-integer-field__button--dec",
        type: "button",
        onClick: function onClick() {
          setValue(alias, getValues()[alias] - 1, {
            shouldValidate: true
          });
        },
        tabIndex: -1,
        "aria-hidden": "true"
      }), jsx("input", Object.assign({
        type: "number"
      }, register(alias, {
        valueAsNumber: true,
        required: mandatoryValidation && mandatoryValidation.errorMessage,
        max: maxValueValidation && {
          value: maxValueValidation === null || maxValueValidation === void 0 ? void 0 : maxValueValidation.value,
          message: maxValueValidation === null || maxValueValidation === void 0 ? void 0 : maxValueValidation.errorMessage
        },
        min: minValueValidation && {
          value: minValueValidation === null || minValueValidation === void 0 ? void 0 : minValueValidation.value,
          message: minValueValidation === null || minValueValidation === void 0 ? void 0 : minValueValidation.errorMessage
        }
      }), {
        defaultValue: defaultValue,
        className: classNames('pp-integer-field__input', {
          'pp-integer-field__input--error': Boolean(errors === null || errors === void 0 ? void 0 : errors[alias])
        }),
        id: id
      })), jsx("button", {
        className: "pp-integer-field__button pp-integer-field__button--inc",
        type: "button",
        onClick: function onClick() {
          setValue(alias, getValues()[alias] + 1, {
            shouldValidate: true
          });
        },
        tabIndex: -1,
        "aria-hidden": "true"
      })]
    })), jsx(ErrorMessage, {
      message: (_a = errors[alias]) === null || _a === void 0 ? void 0 : _a.message
    })]
  })) : null;
};
export { IntegerField };